import { queryOptions } from '@tanstack/react-query'
import {
  DP_PREVIEW_POLL_INTERVAL_MS,
  DP_PREVIEW_POLL_TIMEOUT_MESSAGE,
  DP_PREVIEW_STATUS_MAX_RETRIES,
  DP_PREVIEW_STATUS_RETRY_BASE_DELAY_MS,
  fetchDpPreviewStatus,
  isGeneratingDpPreviewStatus,
  isRetryableDpPreviewStatusError
} from './api'
import { digitalProofingKeys } from './keys'

export const dpPreviewStatusQueryOptions = (productId: number) =>
  queryOptions({
    queryKey: digitalProofingKeys.previewStatus.byProductId(productId),
    queryFn: ({ signal }) => fetchDpPreviewStatus(productId, signal),
    // Successful pending responses keep polling; only failed status requests retry
    retry: (failureCount, error) =>
      failureCount < DP_PREVIEW_STATUS_MAX_RETRIES && isRetryableDpPreviewStatusError(error),
    retryDelay: attempt => Math.min(DP_PREVIEW_STATUS_RETRY_BASE_DELAY_MS * 2 ** attempt, 10_000),
    refetchInterval: query => {
      if (query.state.error) return false

      return isGeneratingDpPreviewStatus(query.state.data?.proof_status) ? DP_PREVIEW_POLL_INTERVAL_MS : false
    },
    refetchOnWindowFocus: false,
    refetchOnReconnect: query => {
      if (query.state.error instanceof Error && query.state.error.message === DP_PREVIEW_POLL_TIMEOUT_MESSAGE) {
        return false
      }

      return (
        isGeneratingDpPreviewStatus(query.state.data?.proof_status) ||
        isRetryableDpPreviewStatusError(query.state.error)
      )
    }
  })
